import type { ComponentProps } from 'react';
import { cn } from '@shared/lib';
import styles from './Skeleton.module.css';

export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn('rounded-md', styles.shimmer, className)}
      {...props}
    />
  );
}
